import { EnqueueToastFn } from 'common/ui/Toaster/Toaster';
import { AllReporterVariant } from '../../hooks/useReporter';
import { EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import { SetterOrUpdater } from 'recoil';
import { Key } from 'slate-react';
import { Editor, Range } from 'slate';

export const REQUIRED_FIELDS_PLUGIN_ID = 'requiredFields' as const;
export type RequiredFieldsPluginID = typeof REQUIRED_FIELDS_PLUGIN_ID;

export type RequiredFieldsPluginOptions = Readonly<
  EditorPluginOptions & {
    setConfirmDeletionDialogState?: SetterOrUpdater<{
      deleteCallback: () => void;
      open: boolean;
      isMultiple: boolean;
    }>;
    isDialogOpenRef?: {
      current: boolean;
    };
    variant?: AllReporterVariant;
    enqueueToast?: EnqueueToastFn;
    onInsertTextRequiredField?: (path: Key) => void;
    syncRequiredFields?: (selection: Range, editor: Editor) => void;
  }
>;

export type RequiredFieldsPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    RequiredFieldsPluginOptions & {
      pluginID: RequiredFieldsPluginID;
      pluginName: string;
    }
>;
